import { isNil } from "lodash";
import { array_to_string, string_to_array } from "./ArrayHelper";
import env from "../env.json";

// Mirrors backend/utils/auth_helper.js's require_group InternalDevelopers
// handling - same reasoning (one shared Cognito pool, so an
// "InternalDevelopers" env-scoped mapping has to live in each deployed
// environment's own code, not in Cognito itself). This is a UI convenience
// only (hides/shows nav and buttons) - the backend's own require_group is
// what actually enforces access, independently of anything here.
// env.DEBUG is already this build's dev/prod flag (envs/dev.json has
// DEBUG:true, envs/prod.json has DEBUG:false, copied to env.json at deploy
// time - see App.js, which already reads it the same way).
const PROD_DEVELOPER_GRANTS = []; // keep in sync with auth_helper.js's PROD_DEVELOPER_GRANTS

const is_dev_developer_bypass = (groups) => {
    return env.DEBUG && check_tab_access(groups, 'InternalDevelopers')
}

const has_prod_developer_grant = (groups, tab_name) => {
    return !env.DEBUG && check_tab_access(groups, 'InternalDevelopers') && PROD_DEVELOPER_GRANTS.includes(tab_name)
}

const check_feature_access = (groups, tab_name) => {
    return check_tab_access(groups, tab_name) || check_tab_access(groups, 'Admin')
        || is_dev_developer_bypass(groups) || has_prod_developer_grant(groups, tab_name)
}

const check_analytics_access = (groups) => {
    return check_feature_access(groups, 'Analytics')
}

const check_ecs_access = (groups) => {
    return check_feature_access(groups, 'ECS')
}

const check_monitoring_access = (groups) => {
    return check_feature_access(groups, 'Monitoring')
}

const check_abs_access = (groups) => {
    return check_feature_access(groups, 'ABS')
}

const check_admin_access = (groups) => {
    return check_tab_access(groups, 'Admin') || is_dev_developer_bypass(groups)
}

const conv_groups_array_for_state = (groups) => {
    return array_to_string(groups);
}

const check_tab_access = (groups, tab_name) => {
    if (isNil(groups)){
        return false;
    }
    groups = string_to_array(groups, ',');
    return groups.includes(tab_name);
}

export { conv_groups_array_for_state, check_analytics_access, check_ecs_access, check_monitoring_access, check_admin_access, check_tab_access,check_abs_access }